import styled from "styled-components";
import CloseIcon from "@mui/icons-material/Close";

export const IconClose = styled(CloseIcon)`
	&&& {
		cursor: pointer;
	}
`;

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	height: 100%;
	max-height: 300px;
	overflow: auto;
`;
